(function () {
  var LABEL = 'Sleep je bestand hierheen of klik hier om bestanden toe te voegen';

  function enhanceFileUpload(input) {
    var zone = input.closest('.wpcf7-form-control-wrap');
    if (!zone || zone.classList.contains('is-upload-enhanced')) return;
    zone.classList.add('is-upload-enhanced');

    var ui = document.createElement('div');
    ui.className = 'c-file-upload';
    ui.innerHTML =
      '<span class="c-file-upload__icon" aria-hidden="true"></span>' +
      '<span class="c-file-upload__text">' +
      '<span class="c-file-upload__filename"></span>' +
      '<span class="c-file-upload__label">' +
      LABEL +
      '</span>' +
      '</span>';
    zone.insertBefore(ui, input);

    var filename = ui.querySelector('.c-file-upload__filename');

    function syncFileState() {
      if (input.files && input.files.length) {
        filename.textContent = input.files[0].name;
        zone.classList.add('has-file');
      } else {
        filename.textContent = '';
        zone.classList.remove('has-file');
      }
    }

    input.addEventListener('change', syncFileState);

    var form = input.closest('form');
    if (form) {
      ['reset', 'wpcf7reset', 'wpcf7mailsent'].forEach(function (evt) {
        form.addEventListener(evt, function () {
          window.setTimeout(syncFileState, 0);
        });
      });
    }

    ['dragenter', 'dragover'].forEach(function (evt) {
      input.addEventListener(evt, function () {
        zone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'dragend', 'drop'].forEach(function (evt) {
      input.addEventListener(evt, function () {
        zone.classList.remove('is-dragover');
      });
    });
  }

  function initFileUploads() {
    document.querySelectorAll('.wpcf7-file').forEach(enhanceFileUpload);
  }

  if (document.readyState !== 'loading') {
    initFileUploads();
  } else {
    document.addEventListener('DOMContentLoaded', initFileUploads);
  }
})();
